import { render, staticRenderFns } from "./demandCustomize.vue?vue&type=template&id=de90783a&scoped=true&"
import script from "./demandCustomize.vue?vue&type=script&lang=js&"
export * from "./demandCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de90783a",
  null
  
)

export default component.exports